import { Button, Card, Flex, Grid, Image, Typography } from "@payping/web-components";
import { useAppTranslation } from "@/utils";
import { Trans } from "@payping/utils/localeUtils";

import { pluginsListList } from "./data";

interface ItemProps {
  data: (typeof pluginsListList)[keyof typeof pluginsListList];
  addTag: (item: string) => void;
  clickToGetToken: () => void;
}

const ListItem = (props: ItemProps) => {
  const { t } = useAppTranslation();

  const { sm } = Grid.useBreakpoint();
  return (
    <Card.Ant>
      <Flex gap="1rem" vertical={!sm}>
        <Image preview={false} src={props.data.logo} width={100} height={100} className="tw-min-w-[100px]" />
        <Flex vertical gap="0.5rem">
          <Typography.Title level={5}>
            {t(`connections.plugins.list.${props.data.translationKey}.title`)}
          </Typography.Title>{" "}
          <Flex wrap="wrap" gap="0.5rem">
            {props.data.tags?.length
              ? props.data.tags.map((item) => (
                  <Button
                    type="link"
                    className="color--black tw-m-0 tw-p-0"
                    key={item}
                    onClick={() => props.addTag(item)}
                  >
                    {t(`connections.plugins.tags.${item}`)}
                  </Button>
                ))
              : null}
          </Flex>
          <Typography.Paragraph type="secondary" className="tw-mt-4">
            <Trans
              i18nKey={`connections.plugins.list.${props.data.translationKey}.description`}
              components={{ p: <Typography.Paragraph type="secondary" /> }}
            />
          </Typography.Paragraph>
          <Flex gap="0.5rem" wrap="wrap">
            <Button
              onClick={() => {
                props.clickToGetToken();
              }}
              type="primary"
              data-google-track={props.data.receiveTokenGoogleTrackId}
            >
              {t("common.receiveToken")}
            </Button>

            {typeof props.data.downloadLink === "string" ? (
              <a
                href={props.data.downloadLink || ""}
                target="_blank"
                rel="noreferrer"
                data-google-track={props.data.downloadLinkGoogleTrackId}
              >
                <Button>{t("common.download")}</Button>
              </a>
            ) : null}

            {props.data.helpLink ? (
              <a
                href={props.data.helpLink}
                target="_blank"
                rel="noreferrer"
                data-google-track={props.data.helpLinkGoogleTrackId}
              >
                <Button type="link">{t("userManual")}</Button>
              </a>
            ) : null}
          </Flex>
          {typeof props.data.downloadLink === "string" ? null : (
            <Flex gap="2rem" vertical className="tw-mt-4">
              {props.data.downloadLink?.map((item) => (
                <Flex key={item.translationKey} vertical gap="0.5rem">
                  <Typography.Text strong>{t(`connections.plugins.list.${item.translationKey}.title`)}</Typography.Text>
                  <Typography.Paragraph className="!tw-m-0">
                    {t(`connections.plugins.list.${item.translationKey}.description`)}
                  </Typography.Paragraph>
                  <a href={item.downloadLink || ""} target="_blank" rel="noreferrer">
                    <Button>{t("common.download")}</Button>
                  </a>
                </Flex>
              ))}
            </Flex>
          )}
        </Flex>
      </Flex>
    </Card.Ant>
  );
};

export default ListItem;
